<template>
  <ui-modal
    ref="modal"
    id="costosServicioIntegral"
    :title="
      !is_editing
        ? 'Asignación de tarifa de servicio'
        : 'Edición de tarifa de servicio'
    "
    @close="actionSetOpenAddExtraCostsISModal(false)"
  >
    <Loading v-if="loadingAddExtraCostsIS" />

    <div v-else>
      <div
        v-if="status === 404"
        style="height: 350px"
        class="w-100 d-flex justify-content-center align-items-center flex-column"
      >
        <i class="fas fa-frown" style="font-size: 100px; color: grey"></i>
        <div
          v-text="message"
          class="mt-3"
          style="color: grey; font-size: 1rem"
        ></div>
      </div>

      <div v-else class="d-flex w-100 flex-column p-3">
        <div class="d-flex">

          <ui-select
            class="w-50"
            has-search
            label="Tipos de extra costos (*)"
            searchPlaceholder="Buscar"
            placeholder="Seleccionar extra costo"
            :options="extraCostsTypeListGrouped"
            v-model="tipoExtraCostosModel"
            :keys="{ value: 'id', label: 'name' }"
            @change="handleExtraCostTypeChange"
          />

          <ui-select
            v-if="isPlantCarrierType"
            class="w-50 ml-3"
            has-search
            label="Planta/Bodega (*)"
            placeholder="Seleccionar extra costo"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="listaPlantas"
            v-model="plantaModel"
            @change="obtenerProveedores(tipoExtraCostosModel)"
            :disabled="validLocality"
          />

           <ui-select
              v-else
              class="w-50 ml-3"
              has-search
              placeholder="Seleccionar proveedor"
              label="Proveedores (*)"
              searchPlaceholder="Buscar"
              :options="optionsProveedores"
              :keys="{ label: 'name', value: 'id' }"
              v-model="proveedoresModel"
              @change="asignacionValoresCurrency(proveedoresModel)"
            />

        </div>

        <div class="d-flex mt-3">
          <ui-select
            v-if="!is_documental_service"
            class="w-50"
            has-search
            placeholder="Seleccionar proveedor"
            label="Proveedores (*)"
            searchPlaceholder="Buscar"
            :options="optionsProveedores"
            :keys="{ label: 'name', value: 'id' }"
            v-model="proveedoresModel"
            @change="asignacionValoresCurrency(proveedoresModel)"
          />

          <div class="w-50" v-if="is_boarding_instruction">
            <!-- Lista Asignación por tipo -->
            <div class="d-flex flex-column w-100 ml-3">
              <!-- Lista de contenedores existentes -->
              <div
                class="d-flex align-items-center w-100"
                v-if="!add_container"
              >
                <ui-select
                  class="w-100"
                  label="Contenedores asociados"
                  placeholder="Seleccione un contenedor"
                  :options="containersList"
                  :keys="{ label: 'name', value: 'id' }"
                  v-model="containerModel"
                />

                <Button
                  tooltip="Agregar contenedor"
                  class="ml-4"
                  :size="16"
                  icon="icon fas fa-plus"
                  color="#2da44e"
                  :width="32"
                  round
                  colorText="#ffffff"
                  @click.native="add_container = true"
                />
              </div>

              <!-- Formulario para crear contenedores -->
              <div class="d-flex align-items-center w-100" v-else>
                <div class="d-flex w-100">
                  <ui-textbox
                    class="w-50"
                    floatingLabel
                    label="No. contenedor"
                    v-model="newContainerModel"
                  />

                  <ui-textbox
                    class="w-50"
                    floatingLabel
                    label="Bill landing"
                    v-model="billLadingModel"
                  />
                </div>

                <div class="d-flex w-25">
                  <Button
                    tooltip="Volver a listar contenedores"
                    class="ml-3"
                    :size="16"
                    icon="fas fa-chevron-left"
                    color="#0d6efd"
                    :width="32"
                    round
                    colorText="#ffffff"
                    @click.native="add_container = false"
                  />

                  <Button
                    class="ml-2"
                    :size="16"
                    icon="fas fa-save"
                    color="#ffa500"
                    :width="32"
                    round
                    colorText="#ffffff"
                    @click.native="createContainer"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex">
          <ui-textbox
            class="w-50"
            floatingLabel
            label="Costo (*)"
            enforce-maxlength
            type="number"
            v-model="netaModel"
          />

          <ui-textbox
            class="w-50 ml-3"
            floatingLabel
            label="Venta (*)"
            enforce-maxlength
            type="number"
            v-model="publicaModel"
          />
        </div>

        <div v-if="sinTarifaClienteTerrestre" class="text-danger mt-1" style="font-size: 0.8rem">
          El cliente no tiene tarifa terrestre para esta combinación.
        </div>

        <div class="d-flex mt-3">
          <ui-select
            class="w-50"
            has-search
            label="Formas de pago (*)"
            placeholder="Seleccionar tipo"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="paymentMethodList"
            v-model="metodoPagoModel"
          />

          <ui-select
            class="w-50 ml-3"
            has-search
            label="Tipo de moneda (*)"
            placeholder="Seleccionar cargo"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="listCurrencies"
            v-model="tipoMonedaModel"
          />
        </div>

        <div class="d-flex mt-3">
          <ui-select
            class="w-100"
            has-search
            label="¿Este cargo se debe manifestar en BL? (*)"
            placeholder="Seleccionar estado"
            searchPlaceholder="Buscar"
            :options="optionsBase"
            :keys="{ label: 'name', value: 'id' }"
            v-model="blModel"
          />

          <ui-select
            class="w-100 ml-3"
            label="IVA (*)"
            placeholder="Seleccionar opción"
            :options="optionsBase"
            :keys="{ label: 'name', value: 'id' }"
            v-model="ivaModel"
          />

          <div class="w-100 ml-3">
            <label>Fecha de servicio (*)</label>
            <input
              class="form-control"
              style="margin-top: -10px"
              type="date"
              lang="es"
              v-model="grantedDateModel"
            />
          </div>
        </div>

        <div class="d-flex mt-1">
          <ui-textbox
            class="w-100"
            floatingLabel
            label="Comentarios"
            enforce-maxlength
            :maxlength="150"
            v-model="comentariosModel"
          />
        </div>

        <!-- Botones -->
        <div class="d-flex justify-content-between pt-3">
          <Button
            :size="23"
            color="#dc3545"
            colorText="#ffffff"
            :width="120"
            :height="35"
            text="Cerrar"
            @click.native="actionSetOpenAddExtraCostsISModal(false)"
          />

          <Button
            v-if="!is_editing"
            :size="23"
            color="#2da44e"
            colorText="#ffffff"
            :width="120"
            :height="35"
            text="Agregar"
            @click.native="validarCampos"
            :inactive="isSending || sinTarifaClienteTerrestre"
          />

          <Button
            v-if="is_editing"
            :size="23"
            color="#2da44e"
            colorText="#ffffff"
            :width="120"
            :height="35"
            text="Guardar"
            @click.native="validarCampos"
            :inactive="isSending"
          />
        </div>
      </div>
    </div>
  </ui-modal>
</template>

<script>
import { mapActions, mapState } from "vuex";
import UiModal from "keen-ui/src/UiModal";
import UiTextbox from "keen-ui/src/UiTextbox";
import UiSelect from "keen-ui/src/UiSelect";
import Button from "../../../../common/Button.vue";

import {
  addExtraCostIS,
  editExtraCostIS,
  getExtraCostsISProvidersLists,
} from "@/constants/serviciosLogisticos";
import Loading from "@/components/common/loading.vue";
import { createOrUpdateContainers } from "@/constants/liquidations";

export default {
  props: {
    boarding_instruction_id: {
      type: [Number],
      default: null,
    },
    service_order_id: {
      type: [Number],
      default: null,
    },
    deposit_id: {
      type: [Number],
      default: null,
    },
    is_boarding_instruction: {
      type: Boolean,
      default: false,
    },
    extra_cost_data: {
      type: [Object, Array],
      default: null,
    },
    extra_cost_id: {
      type: [Number],
      default: null,
    },
    is_editing: {
      type: Boolean,
      default: false,
    },
    booking_number: {
      type: String,
      default: null,
    },

    is_documental_service: {
      type: Boolean,
      default: false,
    },
  },

  components: { UiModal, UiTextbox, UiSelect, Button, Loading },

  computed: {
    ...mapState("serviciosLogisticos", [
      "addExtraCostISModalVisibility",
      "extraCostsTypeList",
      "listaPlantas",
      "listCurrencies",
      "unityPayments",
      "paymentMethodList",
      "status",
      "message",
      "loadingAddExtraCostsIS",
      "selectedLocality",
      "containersList",
    ]),

    isPlantCarrierType() {
      return parseInt(this.tipoExtraCostosModel.id_carrier_type, 10) === 1;
    },

    // Tipos de extra costos agrupados (Documental / Terrestre / Extra costos) con encabezados
    // no seleccionables, igual que en Bookings Embarcados.
    extraCostsTypeListGrouped() {
      const list = this.extraCostsTypeList || [];
      const grupos = ["Documental", "Terrestre", "Extra costos"];
      const out = [];

      grupos.forEach((g) => {
        const items = list.filter((i) => i.grupo === g);
        if (items.length) {
          out.push({ id: `__h_${g}`, name: `── ${g.toUpperCase()} ──`, isHeader: true });
          items.forEach((i) => out.push(i));
        }
      });

      // Fallback: si los items no traen 'grupo', mostrar la lista tal cual.
      return out.length ? out : list;
    },
  },

  data() {
    return {
      tipoExtraCostosModel: {},
      plantaModel: {},
      tipoMonedaModel: {},
      metodoPagoModel: {},
      unidadPagoModel: {},
      optionsBase: [
        { id: 0, name: "No" },
        { id: 1, name: "Si" },
      ],
      optionsProveedores: [],
      proveedoresModel: {},
      netaModel: null,
      publicaModel: null,
      grantedDateModel: "",
      blModel: {},
      ivaModel: {},
      comentariosModel: "",
      isSending: false,
      isLoading: false,
      validLocality: false,
      // Terrestre: true cuando el cliente no tiene tarifa para la combinación → Venta vacía y se bloquea el agregado.
      sinTarifaClienteTerrestre: false,
      //
      containerModel: {},
      newContainerModel: "",
      billLadingModel: "",
      add_container: false,
    };
  },

  methods: {
    ...mapActions("serviciosLogisticos", [
      "actionSetOpenAddExtraCostsISModal",
      "actionSetExtraCostsISLists",
      "actionSetExtraCostISData",
      "actionSetContainerToList",
    ]),

    openModal(ref) {
      this.$refs[ref].open();
    },

    closeModal(ref) {
      this.$refs[ref].close();
    },

    validarCampos() {
      const grantedDateValid = !!String(this.grantedDateModel ?? "").trim();
      const plantaValid =
        !this.isPlantCarrierType || Object.keys(this.plantaModel).length > 0;

      if (
        !this.sinTarifaClienteTerrestre &&
        Object.keys(this.tipoExtraCostosModel).length > 0 &&
        Object.keys(this.proveedoresModel).length > 0 &&
        plantaValid &&
        Object.keys(this.unidadPagoModel).length > 0 &&
        this.netaModel !== "" &&
        this.publicaModel !== "" &&
        Object.keys(this.metodoPagoModel).length > 0 &&
        Object.keys(this.tipoMonedaModel).length > 0 &&
        Object.keys(this.blModel).length > 0 &&
        Object.keys(this.ivaModel).length > 0 &&
        grantedDateValid
      ) {
        this.enviarFormulario();
      } else {
        this.$vToastify.warning(
          "Existen campos que no fueron completados",
          "¡Precaución!"
        );
      }
    },

    async enviarFormulario() {
      this.isSending = true;

      this.$vToastify.loader("Asignando Extra Costo...", "Procesando...");

      let response = null;

      if (!this.is_editing) {
        response = await addExtraCostIS({
          extra_cost_type_id: this.tipoExtraCostosModel.id,
          provider_id: this.proveedoresModel.id,
          plant_id: this.isPlantCarrierType ? this.plantaModel.id : null,
          net: this.netaModel,
          public: this.publicaModel,
          currency_id: this.tipoMonedaModel.id,
          payment_method_id: this.metodoPagoModel.id,
          service_order_id: this.service_order_id,
          boarding_instruction_id: this.boarding_instruction_id,
          id_liquidation_imported_container: this.containerModel.id,
          is_boarding_instruction: this.is_boarding_instruction,
          is_bl: this.blModel.id,
          is_iva: this.ivaModel.id,
          granted_at: this.grantedDateModel,
          comments: this.comentariosModel,
        });
      } else {
        response = await editExtraCostIS({
          extra_cost_id: this.extra_cost_id,
          extra_cost_type_id: this.tipoExtraCostosModel.id,
          provider_id: this.proveedoresModel.id,
          plant_id: this.isPlantCarrierType ? this.plantaModel.id : null,
          net: this.netaModel,
          public: this.publicaModel,
          currency_id: this.tipoMonedaModel.id,
          payment_method_id: this.metodoPagoModel.id,
          service_order_id: this.service_order_id,
          boarding_instruction_id: this.boarding_instruction_id,
          id_liquidation_imported_container: this.containerModel.id,
          is_boarding_instruction: this.is_boarding_instruction,
          is_bl: this.blModel.id,
          is_iva: this.ivaModel.id,
          granted_at: this.grantedDateModel,
          comments: this.comentariosModel,
        });
      }

      // Detener el loader siempre (evita que quede en "Procesando" ante errores/sin respuesta).
      this.$vToastify.stopLoader();

      const { status, message, errors } = response || {};

      if (status === 200) {
        this.closeModal("modal");

        await this.refreshExtraCosts();

        this.$vToastify.success(message, "¡Éxito!");

        this.limpiarFormulario();
      } else {
        const errorMsg =
          message ||
          (errors ? Object.values(errors).flat().join(" ") : "No se pudo guardar la tarifa.");

        this.$vToastify.warning(errorMsg, "¡Precaución!");

        this.isSending = false;
      }
    },

    async refreshExtraCosts() {
      let data = this.is_boarding_instruction
        ? { boarding_instruction_id: this.boarding_instruction_id }
        : { service_order_id: this.service_order_id };

      await this.actionSetExtraCostISData(data);
    },

    limpiarFormulario() {
      this.tipoExtraCostosModel = {};

      this.proveedoresModel = {};

      this.plantaModel = {};

      this.netaModel = null;

      this.publicaModel = null;

      this.tipoMonedaModel = {};

      this.metodoPagoModel = {};

      this.blModel = {};

      this.ivaModel = {};

      this.grantedDateModel = "";

      this.comentariosModel = "";

      this.containerModel = {};

      this.newContainerModel = "";

      this.add_container = false;

      this.isSending = false;

      this.sinTarifaClienteTerrestre = false;

      this.$emit("ec-modal-closed");
    },

    async obtenerDatosBase() {
      await this.actionSetExtraCostsISLists({
        is_boarding_instruction: this.is_boarding_instruction,
        boarding_instruction_id: this.boarding_instruction_id,
        service_order_id: this.service_order_id,
      });
    },

    async setPublicValue({ value }) {
      this.publicaModel = value;
    },

    async handleExtraCostTypeChange() {
      // Los encabezados de grupo no son seleccionables.
      if (this.tipoExtraCostosModel && this.tipoExtraCostosModel.isHeader) {
        this.tipoExtraCostosModel = {};
        return;
      }

      this.sinTarifaClienteTerrestre = false;
      this.proveedoresModel = {};
      this.optionsProveedores = [];

      if (!this.isPlantCarrierType) {
        // Documental / Extra costos: Venta por defecto = valor del tipo.
        this.setPublicValue(this.tipoExtraCostosModel);
        await this.obtenerProveedores();
      } else {
        // Terrestre: la Venta es la tarifa de cliente y se asigna al elegir el proveedor.
        this.publicaModel = null;
      }
    },

    async obtenerProveedores() {
      const canFetchProviders =
        this.tipoExtraCostosModel.id &&
        (!this.isPlantCarrierType || this.plantaModel.id);

      if (canFetchProviders) {
        this.unidadPagoModel = { id: 2, name: "Contenedor" };

        this.metodoPagoModel = { id: 2, name: "Prepaid - PP" };

        const { status, data } = await getExtraCostsISProvidersLists({
          deposit_id: this.deposit_id,
          plant_locality: this.isPlantCarrierType ? this.plantaModel.id : null,
          extra_cost_type_id: this.tipoExtraCostosModel.id,
          boarding_instruction_id: this.boarding_instruction_id,
          service_order_id: this.service_order_id,
          is_boarding_instruction: this.is_boarding_instruction,
        });

        this.optionsProveedores = status === 200 ? data : [];
      }
    },

    asignacionValoresCurrency({ id_currency, name_currency, value, sale_value }) {
      this.tipoMonedaModel = { id: id_currency, name: name_currency };
      this.netaModel = value;

      if (this.isPlantCarrierType) {
        // Venta = tarifa de cliente (clientes_terrestres) para la combinación retiro/planta/entrega/contenedor/tier.
        // Si el cliente no tiene tarifa, la Venta queda vacía y se bloquea el agregado.
        const tieneTarifaCliente = sale_value !== undefined && sale_value !== null;
        this.sinTarifaClienteTerrestre = !tieneTarifaCliente;
        this.publicaModel = tieneTarifaCliente ? sale_value : null;

        if (!tieneTarifaCliente) {
          this.$vToastify.warning(
            "El cliente no tiene tarifa terrestre para esta combinación",
            "¡Precaución!"
          );
        }
      }
    },

    async createContainer() {
      if (this.newContainerModel === "") {
        return this.$vToastify.error(
          "Por favor, complete el espacio Container Number",
          "Error: Container Number"
        );
      }

      this.isSending = true;

      this.$vToastify.loader("Espere por favor...");

      const { status, message, container } = await createOrUpdateContainers({
        creating: true,
        booking_number: this.booking_number,
        container_number: this.newContainerModel,
        bill_lading: this.billLadingModel,
      });

      if (status === 200) {
        this.add_container = false;

        this.containerModel = {
          id: container.id,
          name: container.container_number,
        };

        this.actionSetContainerToList(this.containerModel);

        this.$vToastify.success(message, "Éxito");

        this.isSending = false;
      } else {
        this.$vToastify.error(message, "Error");

        this.isSending = false;
      }

      this.$vToastify.stopLoader();
    },
  },

  watch: {
    addExtraCostISModalVisibility: function (_new) {
      if (_new) {
        this.openModal("modal");

        this.obtenerDatosBase();
      } else {
        this.isLoading = false;

        this.limpiarFormulario();

        this.closeModal("modal");
      }
    },

    listaPlantas: function (_new) {
      if (_new.length > 0 && this.selectedLocality.id) {
        const exists = _new.some(
          (item) => item.id === this.selectedLocality.id
        );

        if (exists) {
          this.validLocality = true;

          this.plantaModel = this.selectedLocality;
        }
      }
    },

    extra_cost_data: async function (_new) {
      if (Object.keys(_new).length > 0) {
        this.isLoading = true;

        const { data, data_complementaria } = _new;


        const {
          id,
          tipo_extra_costo,
          id_carrier_type,
          extra_costo_asignado_por,
          localidad,
          container_number,
          proveedor,
          forma_pago,
          moneda,
          bl,
          estado_iva,
          granted_at,
        } = data_complementaria;

        //this.actionsSetTiposExtraCostos(tipos_extra_costo ) ;

        this.tipoAsignacionModel = extra_costo_asignado_por;

        this.tipoExtraCostosModel = tipo_extra_costo;
        
        this.tipoExtraCostosModel.id_carrier_type = id_carrier_type;

        this.id_extra_costo = id;

        this.plantaModel = localidad;

        this.containerModel = container_number;

        this.netaModel = data[8];

        this.publicaModel = data[9];

        this.metodoPagoModel = forma_pago;

        this.tipoMonedaModel = moneda;

        //this.navieraModel = data[12];

        //this.puertoModel = data[13];

        this.blModel = {
          id: bl.id === 0 ? 0 : 1,
          name: bl.id === 0 ? "No" : "Si",
        };

        this.ivaModel =
          estado_iva === "No" ? { id: 0, name: "No" } : { id: 1, name: "Si" };

        this.grantedDateModel = granted_at;

        this.comentariosModel = data[15];

        this.proveedoresModel = proveedor;

        await this.obtenerProveedores();

        this.isLoading = false;
      }
    },

    booking_number: function (_new, _old) {
      if (_new !== _old) {
        this.limpiarFormulario();
      }
    },

    boarding_instruction_id: function (_new, _old) {
      if (_new !== _old) {
        this.limpiarFormulario();
      }
    },

    service_order_id: function (_new, _old) {
      if (_new !== _old) {
        this.limpiarFormulario();
      }
    },
  },
};
</script>

<style>
#costosServicioIntegral > .ui-modal__wrapper > .ui-modal__container {
  width: 60% !important;
}
</style>
